import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { crmApi, formatApiError } from "@/orbit/lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError("Passwords do not match");
      return;
    }
    setLoading(true);
    try {
      await crmApi.post("/auth/reset-password", { token, password });
      toast.success("Password reset — please sign in");
      navigate("/orbit/login", { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Reset failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-8" data-testid="orbit-reset-page">
      <div className="w-full max-w-sm">
        <div className="text-[11px] uppercase tracking-[0.22em] text-[#1E40AF] font-semibold">Orbit CRM</div>
        <h2 className="mt-3 text-2xl font-semibold text-[#0A1F44]">Set a new password</h2>
        <p className="mt-2 text-sm text-slate-500">Choose a strong password (at least 8 characters).</p>

        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="orbit-reset-form">
          <div>
            <label className="text-xs font-medium text-slate-700 uppercase tracking-wide">New password</label>
            <input type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)}
              data-testid="orbit-reset-password"
              className="mt-1.5 block w-full rounded-md border border-slate-300 px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#1E40AF]/40 focus:border-[#1E40AF]" />
          </div>
          <div>
            <label className="text-xs font-medium text-slate-700 uppercase tracking-wide">Confirm password</label>
            <input type="password" required minLength={8} value={confirm} onChange={(e) => setConfirm(e.target.value)}
              data-testid="orbit-reset-confirm"
              className="mt-1.5 block w-full rounded-md border border-slate-300 px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#1E40AF]/40 focus:border-[#1E40AF]" />
          </div>
          {error && <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md p-3" data-testid="orbit-reset-error">{error}</div>}
          <button type="submit" disabled={loading} data-testid="orbit-reset-submit"
            className="w-full flex items-center justify-center gap-2 bg-[#0A1F44] text-white py-2.5 rounded-md text-sm font-semibold hover:bg-[#1E40AF] transition disabled:opacity-60">
            {loading && <Loader2 className="w-4 h-4 animate-spin" />} Reset password
          </button>
        </form>

        <p className="mt-6 text-sm text-slate-500">
          <Link to="/orbit/login" className="text-[#1E40AF] font-medium hover:underline">← Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
